import { Timestamp } from "firebase/firestore";

/**
 * Safely converts a Firestore Timestamp, Date, number, or string
 * into a JavaScript Date. Returns null if it can't convert.
 */
export function safeToDate(
  value
) {
  if (!value) return null;

  // Already a JS Date
  if (value instanceof Date) return value;

  // Firestore Timestamp
  if (typeof value.toDate === "function") {
    return value.toDate();
  }

  // Numeric timestamp (seconds or ms)
  if (typeof value === "number") {
    return value < 10_000_000_000 ? new Date(value * 1000) : new Date(value);
  }

  // String date (ISO or RFC2822)
  if (typeof value === "string") {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  return null;
}

